import React from "react";
import moment from "moment";
import { formatCurrency } from "../../../../utils/SamuiUtils";
import { formatThaiDateUi } from "../../../../utils/DateUtils";

export default function DetailModal({
  open,
  onClose,
  data,
  fields,
  info,
  onPrev,
  onNext,
  totalSummary,
}) {
  if (!open) return null;
  return (
    <>
      <div className="modal-backdrop fade show" />
      <div className="modal d-block" tabIndex={-1}>
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                สรุปเจ้าหนี้ค้างจ่าย {info.code} - {info.name}
              </h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>
            <div
              className="modal-body"
              style={{ maxHeight: "80vh", overflowY: "auto" }}
            >
              <div className="table-responsive">
                <table className="table table-striped table-hover">
                  <thead className="thead-dark">
                    <tr>
                      {fields.map((f) => (
                        <th
                          key={f.key}
                          style={{ width: f.w }}
                          className={`text-${f.alignHeader} text-nowrap`}
                        >
                          {f.label}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.length ? (
                      data.map((d, rowIndex) => (
                        <tr key={rowIndex}>
                          {fields.map((f) => {
                            let content;

                            if (f.key === "Doc_Date") {
                              content = formatThaiDateUi(
                                moment(d[f.key])
                              );

                            } else if (
                              f.key === "DocStatusPaid_Name" ||
                              f.key === "DocStatusPaid_Type_Name"
                            ) {
                              let colourKey;
                              if (f.key.endsWith("_Type_Name")) {
                                // "DocStatusPaid_Type_Name" → "DocStatusPaidType_Colour"
                                colourKey = f.key.replace(
                                  "_Type_Name",
                                  "Type_Colour"
                                );
                              } else {
                                colourKey = f.key.replace("_Name", "_Colour");
                              }

                              const bgColor = d[colourKey] || "#ccc";

                              content = (
                                <span
                                  className="badge d-block w-100 text-center"
                                  style={{
                                    backgroundColor: bgColor,
                                    color: "#fff",
                                  }}
                                >
                                  {d[f.key]}
                                </span>
                              );

                            } else if (f.numeric) {
                              content = formatCurrency(d[f.key]);

                            } else {
                              content = d[f.key];
                            }

                            return (
                              <td key={f.key} className={`text-${f.align}`}>
                                {content}
                              </td>
                            );
                          })}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={fields.length}>
                          <center>ไม่พบรายการ</center>
                        </td>
                      </tr>
                    )}
                  </tbody>

                  <tfoot>
                    <tr>
                      <td colSpan={fields.length - 1} className="text-end">
                        รวมทั้งหมด {data.length} รายการ
                      </td>
                      <td className="text-end">
                        {formatCurrency(
                          data.reduce((s, d) => s + (d.NetTotal || 0), 0)
                        )}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
        <div className="modal-footer position-relative justify-content-center">
  <span className="position-absolute start-0 ps-3">
    {info.index + 1} / {totalSummary}
  </span>

  <button
    className="btn btn-outline-orange"
    onClick={onPrev}
    disabled={info.index === 0}
  >
    ก่อนหน้า
  </button>
  <button
    className="btn btn-outline-orange ms-2"
    onClick={onNext}
    disabled={info.index === totalSummary - 1}
  >
    ถัดไป
  </button>
</div>
          </div>
        </div>
      </div>
    </>
  );
}
